import * as React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  TextField,
  Typography,
} from "@mui/material";

const InvoiceDetailDialog = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Hàng hóa/Dịch vụ</DialogTitle>
      <Divider />
      <DialogContent>
        <Grid size={12}>
          <Grid size={12} sx={{ display: "flex" }}>
            <Typography sx={{ minWidth: 200, alignContent: "center" }}>
              Tên hàng hóa/Dịch vụ:
            </Typography>
            <TextField size="small" fullWidth></TextField>
          </Grid>
          <Grid size={6} sx={{ display: "flex" }}>
            <Typography sx={{ minWidth: 200, alignContent: "center" }}>
              ĐVT:
            </Typography>
            <TextField size="small" fullWidth></TextField>
          </Grid>
          <Grid size={6} sx={{ display: "flex" }}>
            <Typography sx={{ minWidth: 200, alignContent: "center" }}>
              Số lượng:
            </Typography>
            <TextField type="number" size="small" fullWidth></TextField>
          </Grid>
          <Grid size={6} sx={{ display: "flex" }}>
            <Typography sx={{ minWidth: 200, alignContent: "center" }}>
              Đơn giá:
            </Typography>
            <TextField type="number" size="small" fullWidth></TextField>
          </Grid>
          <Grid size={6} sx={{ display: "flex" }}>
            <Typography sx={{ minWidth: 200, alignContent: "center" }}>
              Thành tiền:
            </Typography>
            <TextField type="number" size="small" fullWidth></TextField>
          </Grid>
          <Grid size={6} sx={{ display: "flex" }}>
            <Typography sx={{ minWidth: 200, alignContent: "center" }}>
              Thuế suất:
            </Typography>
            <TextField type="number" size="small" fullWidth></TextField>
          </Grid>
          <Grid size={6} sx={{ display: "flex" }}>
            <Typography sx={{ minWidth: 200, alignContent: "center" }}>
              Tiền thuế:
            </Typography>
            <TextField type="number" size="small" fullWidth></TextField>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions></DialogActions>
    </Dialog>
  );
};

export default InvoiceDetailDialog;
